module.exports = __webpack_public_path__ + "assets/img/7c5b5c01d2094de1c9320cb88519f0f0.png";